// extracted by mini-css-extract-plugin
export default {"uploadList":"index-module__fudqa","listItem":"index-module__cO6xQ"};